import React from "react"
import ConfrimIcon from "../../assets/img/advertisement-confirmation.svg"
import Translation from "../../services/translation.service"

const prefix = "stm_advertisement_popup_"

const AdvertisementPopup = ({
    onContinue = () => {}
}) => {
    return (<div className="advertisement-popup-overlay">
        <div className="container">
          <img src={ConfrimIcon} alt="confirmIcon" />
            <p className="title">{Translation.keys[prefix + "title"] || "Successfully saved"}</p>
            <p className="desc">{Translation.keys[prefix + "desc"] || "Your action has been successfully completed."}</p>
        <div className="advertisement-button-section">            
            <button className="storefront-button center-button advertisement-popup" 
            onClick={onContinue}>
            {Translation.keys[prefix + "button"] || "Okay"}
            </button>
          </div>
        </div>
    </div>)
}

export default AdvertisementPopup